import React from "react";
import { motion } from "framer-motion";

const itemVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const OpportunitiesSection = () => {
  const img = `${process.env.PUBLIC_URL || ""}/images/hire.jpg`;

  return (
    <section className="bg-white py-12 md:py-16">
      <div className="max-w-6xl mx-auto px-6 w-full">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-center mb-8 md:mb-10"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          variants={itemVariants}
        >
          Key Areas We Hire ...
        </motion.h2>

        {/* Single image replacing the text rows */}
        <motion.figure
          className="relative w-full max-w-5xl mx-auto rounded-3xl overflow-hidden shadow-xl"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          variants={itemVariants}
          whileHover={{ scale: 1.005 }}
          transition={{ type: "spring", stiffness: 220, damping: 22 }}
        >
          {/* Auto height; capped so it fits one screen on phones */}
          <img
            src={img}
            alt="Hiring opportunities visual"
            className="block w-full h-auto max-h-[58vh] sm:max-h-[62vh] md:max-h-[66vh]"
            loading="lazy"
            decoding="async"
            draggable="false"
          />
          <figcaption className="sr-only">Visual of hiring opportunities</figcaption>
        </motion.figure>
      </div>
    </section>
  );
};

export default OpportunitiesSection;
